import { Component, computed, effect, input, model } from '@angular/core';
import { IUserAccountClientDto } from '@my-aon/auth';
import { DataGridDirective } from '@my-aon/shared';
import { hasValue } from '@my-aon/utils';
import { VendorsModule } from '@my-aon/vendors';
import { ArrayStore, DataSourceOptions } from 'devextreme/common/data';
import { RowInsertedEvent, RowRemovedEvent } from 'devextreme/ui/data_grid';

const SIN_GROUP_ID = 5657;

@Component({
    selector: 'app-account-clients-list',
    templateUrl: './account-clients-list.component.html',
    styleUrl: './account-clients-list.component.scss',
    imports: [
        VendorsModule
    ],
})
export class AccountClientsListComponent extends DataGridDirective<IUserAccountClientDto> {

    loadIndicatorVisible: boolean = false;

    $readOnly = input.required<boolean>({ alias: 'readOnly' });

    $validationGroupName = input<string>('AccountClientsListComponent' + 'ValidationGroupName', { alias: 'validationGroupName' });

    $userId = input.required<string | undefined>({ alias: 'userId' });
    $clientGroupId = input.required<number | undefined>({ alias: 'clientGroupId' });

    $isRequired = computed<boolean>(() => (this.$clientGroupId() === SIN_GROUP_ID));

    $clients = model.required<IUserAccountClientDto[] | undefined>({ alias: 'clients' });

    dataSourceClientGroups?: DataSourceOptions = this.storeService.DataSourceOptions('Admin/ClientGroups', 'Id',
        {
            sort: [{ selector: 'Name' },],
            select: ['Id', 'Name'],
        },
    );

    dataSourceClients: Array<{ Id: number, Name: string, ClientGroupId: number, disabled?: boolean }> = [];
    lookupTrueFalse = { dataSource: [{ value: true, text: 'Yes' }, { value: false, text: 'No' }], valueExpr: 'value', displayExpr: 'text' };
    validationRulesTrueFalse = [{ type: 'custom', message: 'This field is required', validationCallback: (e: any) => (e.value === true || e.value === false) }];

    override dataSource: ArrayStore<IUserAccountClientDto, number> = new ArrayStore({
        key: 'ClientId',
        data: []
    });

    constructor() {

        super();

        effect(() => {

            let clientGroupId = this.$clientGroupId();

            this.storeService.DataSource('Admin/Clients', 'Id',
                {
                    sort: [{ selector: 'Name' },],
                    select: ['Id', 'Name', 'ClientGroupId'],
                    filter: ['ClientGroupId', '=', clientGroupId],
                }
            )
                .load()
                .then(result => {
                    this.dataSourceClients = result;
                })
        });

    }

    updateDataSource(data?: IUserAccountClientDto[]) {

        if (!hasValue(data)) return;

        this.loadIndicatorVisible = true;

        this.dataSource.clear();

        this.changes = [];

        data.forEach(item => this.changes.push({ type: 'insert', key: item.ClientId, data: item }));

        setTimeout(async () => {

            await this.saveEditData();
            this.refresh();
            this.loadIndicatorVisible = false;
        }, 123);
    }



    $allowAdding = computed<boolean>(() => {

        let clientGroupId = this.$clientGroupId();

        if (!hasValue(clientGroupId) || clientGroupId == 0) {
            return false;
        }

        let clients = this.$clients() ?? [];

        if (clientGroupId == SIN_GROUP_ID && clients.length >= 1) {
            return false;
        }

        return true;
    });

    onInitNewRow = ({ data }: { data: IUserAccountClientDto }) => {

        if (hasValue(this.$userId())) {
            data.UserId = this.$userId()!;
        }

        if (hasValue(this.$clientGroupId())) {
            data.ClientGroupId = this.$clientGroupId();
        }
    }

    async onRowInserted({ data, key }: RowInsertedEvent<IUserAccountClientDto>) {
        this.dataSourceClients
            .forEach(client => {
                if (client.Id === data.ClientId) {
                    client.disabled = true;
                }
            })

        this.$clients.set(await this.dataSource.load());
    }

    async onRowRemoved({ data, key }: RowRemovedEvent<IUserAccountClientDto>) {
        this.dataSourceClients
            .forEach(client => {
                if (client.Id === data.ClientId) {
                    client.disabled = false;
                }
            })

        this.$clients.set(await this.dataSource.load());
    }

}
